import React, { useContext, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DownloadingIcon from "@mui/icons-material/Downloading";
import InlineIconButton from "../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import { nullCheck } from "../../../../utils/dataHelpers";
import { formatEmpty } from "../../../../utils/formatHelpers";
import { ImageService } from "../../../../services/ImageService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function DownloadDocumentCell(cell) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const id = nullCheck(cell, "", "row", "original", "id");
  const type = "pdf"; //nullCheck(cell, "", "row", "original", "__type");
  const filename = nullCheck(cell, "", "row", "original", "descr");
  const orderId = nullCheck(cell, "", "column", "orderId");

  const handleClick = () => {
    setIsLoading(true);
    ImageService.GetDocument(instance, type, id).then(res => {
      res.arrayBuffer().then(data => {
        const file = new Blob([data], { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        const anchorElement = document.createElement("a");
        document.body.appendChild(anchorElement);
        anchorElement.style.display = "none";
        anchorElement.href = url;
        anchorElement.download = `${filename}_${orderId}`;
        anchorElement.click();
        URL.revokeObjectURL(url);
      });
      setIsLoading(false);
    }).catch(error => {
      console.error(error);
      setIsLoading(false);
      warning(error);
    });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <StyledTooltip title={cell.value ? cell.value : ""}>
        <Typography variant="body1" color="black_solid.80" className="Customized-table-overflow-cell">{formatEmpty(cell.value)}</Typography>
      </StyledTooltip>
      <StyledTooltip title={isLoading ? "Downloading" : "Download"}>
        <span>
          <InlineIconButton
            icon={isLoading ? DownloadingIcon : FileDownloadOutlinedIcon}
            buttonColor="blue"
            onClick={handleClick}
            disabled={isLoading}
          />
        </span>
      </StyledTooltip>
    </Box>
  );
}